import { BaseHttpError } from './error';

export class ClientError extends BaseHttpError {
  constructor(...params) {
    super(...params);
    this.name = ClientError.getName();
  }

  static getName() {
    return 'ClientError';
  }
}
